import React from "react";
import {connect} from "react-redux";
import {SEARCH_RESULT_DETAIL_SIDEBAR_TITLE, SEARCH_RESULTS_SIDEBAR_TITLE} from "../../../helpers/sidebarsHelper";
import {
  hideProductDetailsAction,
  removeSearchResultDetailsAction,
  storeSearchResultDetailsAction
} from "../../../state/application/actions";
import {
  AllInterferometricStacksType,
  ProductImageStacType,
  SearchResultElementType,
  SearchResultsType
} from "../../../types/product";
import {
  isInterferometricStackSearchResults,
  isProductImageSearchResultElement
} from "../../../helpers/searchResultsHelper";
import {findInterferometricStackFrom} from "../../../helpers/interferometricStackHelper";
import translations from "../../../translations";

interface PropsType {
  allInterferometricStacks: AllInterferometricStacksType,
  searchResultDetails: SearchResultElementType,
  searchResults: SearchResultsType,
  isSearchSidebarToggleVisible: boolean,
  removeSearchResultDetailsActionHandler: any,
  hideProductDetailsActionHandler: any,
  storeSearchResultDetailsActionHandler: any,
  language: string
}

const HeaderSearchResultDetailsSidebar = (props: PropsType) => {
  const {
    allInterferometricStacks,
    searchResultDetails,
    searchResults,
    isSearchSidebarToggleVisible,
    removeSearchResultDetailsActionHandler,
    hideProductDetailsActionHandler,
    storeSearchResultDetailsActionHandler,
    language
  } = props;

  let titlePaddingLeft = 0;
  if (isSearchSidebarToggleVisible) {
    titlePaddingLeft += 170;
  }

  let searchResultDetailSidebarTitle = translations(SEARCH_RESULT_DETAIL_SIDEBAR_TITLE, language);
  let searchResultsSidebarTitle = translations(SEARCH_RESULTS_SIDEBAR_TITLE, language);
  let onClose = () => {
    removeSearchResultDetailsActionHandler();
    hideProductDetailsActionHandler()
  };

  if (isInterferometricStackSearchResults(searchResults) && isProductImageSearchResultElement(searchResultDetails)) {
    searchResultDetailSidebarTitle = "IMAGE STACK DETAILS";
    searchResultsSidebarTitle = "RESULT DETAILS";
    onClose = () => {
      const imageStack = searchResultDetails as ProductImageStacType;
      const stack = findInterferometricStackFrom(allInterferometricStacks, imageStack);
      storeSearchResultDetailsActionHandler(stack);
    }
  }

  return (
    <div className="search-result-details-header sidebar-header d-flex justify-content-between align-items-center px-3 py-4">
      <h6
        className="title-like text-uppercase m-0 text-center"
        title={searchResultDetailSidebarTitle}
        style={{paddingLeft: `${titlePaddingLeft}px`}}
      >
        {searchResultDetailSidebarTitle}
      </h6>
      <button
        className="sidebar-close-btn remove-btn-defaults"
        type="button"
        onClick={onClose}
      >
        <svg>
          <use xlinkHref="#left_arrow-icon" fill="#9A9BA6" />
        </svg>
        <span>{searchResultsSidebarTitle}</span>
      </button>
    </div>
  )
};

const mapStateToProps = (state) => ({
  allInterferometricStacks: state.product.allInterferometricStacks,
  searchResults: state.product.searchResults,
  language: state.application.appParameters.language
});

const mapDispatchToProps = (dispatch) => ({
  removeSearchResultDetailsActionHandler: () => dispatch(removeSearchResultDetailsAction()),
  hideProductDetailsActionHandler: () => dispatch(hideProductDetailsAction()),
  storeSearchResultDetailsActionHandler: (item) => dispatch(storeSearchResultDetailsAction(item))
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSearchResultDetailsSidebar)
